import { fetchChannel as f } from '../api/channels'
import { addChannels } from './channel'

export function fetchChannel(id) {
    return async dispatch => {
        const channel = await f(id)
        dispatch(addChannels([channel, ...channel.children]))
        return channel
    }
}
